import { ColorV2, Text } from "@adoptaunabuelo/react-components";
import { Facebook, Instagram, Linkedin, Twitter, Youtube } from "lucide-react";
import styled from "styled-components";
import media from "styled-media-query";

const Footer = styled.div`
	display: flex;
	flex-direction: column;
	margin-top: 32px;
	padding-top: 32px;
	border-top: 1px solid ${ColorV2.border.neutralSoft};
	gap: 32px;
	${media.lessThan("medium")`
        background-color: ${ColorV2.surface.background};
		margin: 0px -24px;
		padding: 16px 24px 52px;
		border-top: none;
    `}
`;
const IconRow = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	gap: 8px;
`;
const Icon = styled.div`
	display: flex;
	width: 40px;
	height: 40px;
	padding: 8px;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	border-radius: 40px;
	&:hover {
		background-color: ${ColorV2.surface.neutralSoft};
	}
`;
const IconImage = styled.img`
	width: auto;
	height: 42px;
	object-fit: cover;
	cursor: pointer;
`;

const FooterSocialMedia = () => {
	const rrss = [
		{
			icon: <Facebook color={ColorV2.text.neutralHard} />,
			url: "https://www.facebook.com/adoptaunabuelo1",
		},
		{
			icon: <Instagram color={ColorV2.text.neutralHard} />,
			url: "https://www.instagram.com/adopta1abuelo",
		},
		{
			icon: <Twitter color={ColorV2.text.neutralHard} />,
			url: "https://x.com/adoptaunabuelo",
		},
		{
			icon: <Youtube color={ColorV2.text.neutralHard} />,
			url: "https://www.youtube.com/c/AdoptaUnAbuelo",
		},
		{
			icon: <Linkedin color={ColorV2.text.neutralHard} />,
			url: "https://www.linkedin.com/company/adoptaunabuelo",
		},
	];

	return (
		<Footer>
			<div>
				<Text
					type="h4"
					weight="semibold"
					style={{ textAlign: "center" }}
				>
					¡No te pierdas nada!
				</Text>
				<Text
					type="p2"
					style={{
						color: ColorV2.text.neutralMedium,
						marginTop: 16,
						textAlign: "center",
					}}
				>
					Bájate nuestra app si aún no lo has hecho y síguenos en
					nuestras redes sociales, ¡somos más de 1 millón!
				</Text>
			</div>
			<IconRow>
				{rrss.map((item, index) => (
					<Icon
						key={"rrss-" + index}
						onClick={() => window.open(item.url, "_blank")}
					>
						{item.icon}
					</Icon>
				))}
			</IconRow>
			<IconRow>
				<IconImage
					src={require("../../../assets/logo/android.png")}
					onClick={() =>
						window.open(
							"https://play.google.com/store/apps/details?id=com.adoptaunabuelo.app&hl=es_419&gl=ES&pli=1",
							"_blank"
						)
					}
				/>
				<IconImage
					src={require("../../../assets/logo/ios.png")}
					onClick={() =>
						window.open(
							"https://apps.apple.com/es/app/adopta-un-abuelo/id1559513523",
							"_blank"
						)
					}
				/>
			</IconRow>
		</Footer>
	);
};
export default FooterSocialMedia;
